<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Cliente</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field select">
          <div class="select-field">
            <select v-model="form.tipo_identificacion" name="tipo_identificacion" id="tipo_identificacion" :disabled="this.clienteId != ''">
              <option value="">Seleccione...</option>
              <option value="C">Cédula</option>
              <option value="R">Ruc</option>
            </select>
            <label for="tipo_identificacion">Tipo de identificación</label>
            <span
              v-if="errores.tipo_identificacion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.tipo_identificacion[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field :readonly="this.clienteId != ''" placeholder="Escriba un número de identificación..." id="numero_identificacion" v-model="form.numero_identificacion">
            # Identificacion
            <span
              v-if="errores.numero_identificacion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.numero_identificacion[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field placeholder="Escriba un nombre..." id="nombres" v-model="form.nombres">
            Nombre
            <span
              v-if="errores.nombres"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.nombres[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field placeholder="Escriba un segundo nombre..." id="segundo_nombre" v-model="form.segundo_nombre">
            Segundo nombre
            <span
              v-if="errores.segundo_nombre"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.segundo_nombre[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field placeholder="Escriba un apellido..." id="apellidos" v-model="form.apellidos">
            Apellido
            <span
              v-if="errores.apellidos"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.apellidos[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field placeholder="Escriba un apellido..." id="segundo_apellido" v-model="form.segundo_apellido">
            Segundo apellido
            <span
              v-if="errores.segundo_apellido"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.segundo_apellido[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field placeholder="Escriba una dirección..." id="direccion" v-model="form.direccion">
            Dirección
            <span
              v-if="errores.direccion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.direccion[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field placeholder="Escriba uno o varios teléfonos..." id="telefonos" v-model="form.telefonos">
            Teléfonos
            <span
              v-if="errores.telefonos"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.telefonos[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field placeholder="Escriba uno o varios celulares..." id="celulares" v-model="form.celulares">
            Celular
            <span
              v-if="errores.celulares"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.celulares[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field placeholder="$ #,###.##" id="cupo_maximo" v-model="form.cupo_maximo" vMoney :format="money">
            Cupo máximo
            <span
              v-if="errores.cupo_maximo"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.cupo_maximo[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field select">
          <div class="select-field">
            <select
              name="tipo_estado"
              v-model="form.tipoEstado"
              id="tipo_estado"
            >
              <option value="A">ACTIVO</option>
              <option value="I">INCOBRABLE</option>
            </select>
            <label for="tipo_estado">Estado cobro:</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <p><strong>Clave: </strong> {{ clave }}</p>
        </div>
      </div>
      <div class="col-xs-12 col-md-6" v-show="puedeVerClaveAccesoWeb">
        <div class="form-field">
          <p><strong>Clave acceso web: </strong> {{ claveAccesoWeb }}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <fotos-clientes @fotosGuardadas="fotosGuardadas" :fotos="fotos" v-if="clienteId != ''" :clienteId="clienteId"></fotos-clientes>
      </div>
    </div>
    <div class="modal-buttons">
      <button v-if="clienteId != ''" @click="auditoria" class="btn-secondary">
        <i class="fa fa-list"></i><span>Auditoría</span>
      </button>
      <button @click="guardar" class="btn-success">
        <i class="fa fa-save"></i><span>Guardar</span>
      </button>
      <button @click="cancelar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cancelar</span>
      </button>
    </div>
    <modal
      name="clienteAuditoria"
      scrollable
      reset 
      adaptive
      resizable
      height="auto"
      width="50%"
      clickToClose
    >
      <auditoria-cliente
        :clienteId="clienteId"
      ></auditoria-cliente>
    </modal>
  </div>
</template>

<script>
import FotosClientes from './FotosClientes.vue';
export default {
  components: {
    FotosClientes
  },
  props: {
    clienteId: {
      required: false,
      default: ''
    },
    puedeVerClaveAccesoWeb: {
      required: true
    },
  },
  data: function() {
    return {
      money: money,
      nombreCliente: '',
      numeroIdentificacion: '',
      clave: '',
      claveAccesoWeb: '',
      form: {
        tipoEstado: 'A',
        cupo_maximo: 400,
        tipo_identificacion: '',
        direccion: '',
        telefonos: '',
        celulares: '',
        nombres: '',
        numero_identificacion: '',
        segundo_nombre: '',
        apellidos: '',
        segundo_apellido: ''

      },  
      fotos: [],
      errores: {}
    }
  },
  methods: {
    fotosGuardadas: function () {
      this.$emit('fotosGuardadas');
    },
    guardar: function() {
      swal({
        title: "¿Desea almacenar el cliente?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let urlApi = '';
          if (this.clienteId != '')
            urlApi = `${url}/clientes/editar/${this.clienteId}`;
          else 
            urlApi = `${url}/clientes`;
          axios 
            .post(urlApi, this.form)
            .then(response => {
              let advertencia = response.data.advertencia;
              let mensaje = response.data.mensaje;
              if(advertencia){
                swal('Aviso', mensaje, 'warning');
              }
              else{
                swal('Realizado', mensaje, 'success');
                this.$emit('guardar');
              }
            })
            .catch(error => {
              let status = error.response.status;
              if (status == 422) {
                this.errores = error.response.data.errors;
                swal('Error', 'Todos los campos son obligatorios.', 'error');
              }
              else 
                swal('Error', 'No se pudo almacenar a la persona', 'error');
            });
        }
      });      
    },
    auditoria: function() {
      this.$modal.show('clienteAuditoria');
    },
    cancelar: function() {
      this.$emit('cerrar');
    },
    cargarCliente: function() {
      let urlApi = `${url}/clientes/cargar-cliente/${this.clienteId}`;
      axios
        .get(urlApi)
        .then(response => {
          let cliente = response.data.cliente;
          this.form.nombres = cliente.nombres;
          this.form.segundo_nombre = cliente.segundo_nombre;
          this.form.apellidos = cliente.apellidos;
          this.form.segundo_apellido = cliente.segundo_apellido;
          this.form.numero_identificacion = cliente.numero_identificacion;
          this.form.tipoEstado = cliente.tipo_estado;
          this.form.cupo_maximo = cliente.cupo_maximo;
          this.form.telefonos = cliente.telefonos;
          this.form.celulares = cliente.celulares;
          this.form.tipo_identificacion = cliente.tipo_identificacion;
          this.clave = cliente.clave != null ? cliente.clave : ' - ';
          this.form.direccion = cliente.direccion;
          this.claveAccesoWeb = cliente.clave_acceso_web != null ? cliente.clave_acceso_web : ' - ';
          this.fotos.splice(0, this.fotos.length);
          for (let i = 0; i < cliente.fotos.length; i++) {
            this.fotos.push(cliente.fotos[i]);
          }
        })
        .catch(error => {
          swal('Error', 'Hubo un error al cargar al cliente', 'error');
        });
    }
  },
  mounted: function() {
    if (this.clienteId != '')
      this.cargarCliente();
  }

}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/clientes/Cliente.vue